import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconArrowFull = ({
  direction = 'right',
  ...props
}: SvgIconProps & {
  direction?: 'right' | 'left' | 'up' | 'down'
}) => {
  let rotateValue

  switch (direction) {
    case 'right': {
      rotateValue = 'rotate(180deg)'
      break
    }
    case 'left': {
      rotateValue = 'rotate(0deg)'
      break
    }
    case 'down': {
      rotateValue = 'rotate(-90deg)'
      break
    }
    case 'up': {
      rotateValue = 'rotate(90deg)'
      break
    }
  }

  return (
    <SvgIcon
      {...props}
      width="17"
      height="16"
      viewBox="0 0 17 16"
      sx={{ transform: rotateValue, ...props.sx }}
    >
      <g id="Iconex/Light/Left">
        <g id="Left">
          <path
            id="Vector"
            d="M5.86928 10.667L3.67402 8.47173C3.41367 8.21138 3.41367 7.78927 3.67402 7.52892L5.86928 5.33366M3.86928 8.00032L13.2026 8.00032"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            fill="none"
          />
        </g>
      </g>
    </SvgIcon>
  )
}
